import { SIZE } from '@app/constants'
import { PERIODS_VALUES } from '@app/constants/filters'
import { ABNORMAL_STATE, ABNORMAL_STATE_TITLE } from '@app/constants/abnormalState'
import { SEPARATOR } from '@app/constants/separator'

import { LntSelectOption, LntSelectProps } from '@app/components/base/Select/types'

export const commonSelectProps: LntSelectProps<number[]> = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle,
  strictValue: true,
  tokenSeparators: [SEPARATOR.newline]
}

export const periodOptions: LntSelectOption[] = [
  { label: 'Дни', value: PERIODS_VALUES.date },
  { label: 'Недели', value: PERIODS_VALUES.week }
]

export const priceTypeOptions: LntSelectOption[] = [
  { label: 'Только регулярные цены конкурента', value: 'regular_price' },
  { label: 'Только акционные цены конкурента', value: 'promo_price' }
]

export const commentsByUsersOptions: LntSelectOption[] = [
  { label: 'Все мониторинги с комментариями', value: 'all_users' },
  { label: 'Только от КС', value: 'category_manager' },
  { label: 'Только от ЦО', value: 'pricing_specialist' },
  { label: 'Только от АЦ', value: 'price_analytics_specialist' }
]

export const isMatchedWithProductOptions: LntSelectOption[] = [
  { label: 'Сопоставлен', value: 'true' },
  { label: 'Не сопоставлен', value: 'false' }
]

export const abnormalStateOptions: LntSelectOption[] = [
  { label: ABNORMAL_STATE_TITLE.OK, value: ABNORMAL_STATE.OK },
  { label: ABNORMAL_STATE_TITLE.ABNORMAL, value: ABNORMAL_STATE.ABNORMAL },
  { label: ABNORMAL_STATE_TITLE.CHECKED, value: ABNORMAL_STATE.CHECKED }
]
